// material
import {Container, Grid} from '@mui/material';
// components
import Page from '../components/Page';
import * as React from "react";
import Typography from "@mui/material/Typography";
import {useNavigate, useParams} from "react-router-dom";
import * as CommunicationService from "../services/CommunicationService";
import {paymentLinkOrder} from "../services/CommunicationService";
import {createCheckoutSession, checkoutScopeForOrder} from '../services/CheckoutSession';
import * as AlertMapper from "../services/AlertMapper";
import {DOCUMENTS_DETAILS} from "../services/LogicService";
import {linkOrderToTracking} from '../services/tracking/MarketingTracking';

// ----------------------------------------------------------------------


export default function PaymentLinkComplete() {
    let {orderId, shareCode} = useParams();

    const navigate = useNavigate();
    let [text, setText] = React.useState("Se valideaza integritatea datelor...");

    React.useEffect(() => {
        let active = true;
        const sessions = {legacy: createCheckoutSession('legacy'), comenzi: createCheckoutSession('comenzi')};
        CommunicationService.paymentLinkOrder(orderId, shareCode)
            .then(response => {
                if (!active) return;
                if (response.active === false) return setText("Linkul nu mai este activ.");
                const scope = checkoutScopeForOrder(response);
                const session = sessions[scope];
                if (!session.isCurrent()) return;
                session.setOrder(response.orderId, response.price, true, response.paymentCode,
                    response.necessaryDocuments, 'PERSON', undefined, true, response.active,
                    response.fiscalDone, 'FISCAL', {...response, checkoutType: response.promotionCheckoutType});
                session.setToken(response.jwtResponse);
                linkOrderToTracking(response.orderId, {code: shareCode});
                session.addUploadedDocuments({key: DOCUMENTS_DETAILS.SIGNATURE_FOR_LAWYER_CONTRACT.key, uploaded: true});
                navigate(scope === 'comenzi' ? '/comenzi/' : '/');
            })
            .catch(error => {
                if (!active) return;
                try { setText(JSON.parse(error.message).message); }
                catch (_) { setText(error.message); }
            });
        return () => { active = false; };
    }, [orderId, shareCode, navigate]);

    return (
        <Page title="Cazier Judiciar Online – Eliberare Cazier Fara Deplasari">
            <Container maxWidth="xl">
                <Grid container spacing={5} align={"center"}>


                    <Grid item xs={12} md={12} lg={12}>
                        <Typography component="div" variant="h3">
                            {text}
                        </Typography>
                    </Grid>

                </Grid>
            </Container>
        </Page>
    );
}
